import { useNavigate } from "react-router-dom";
import { t, font } from "@realtyflows/ui";

const linkStyle = {
  cursor: "pointer",
  textTransform: "uppercase",
  letterSpacing: 2,
  fontSize: 10,
  fontWeight: 700,
  fontFamily: font.body,
  color: t.textMuted,
  transition: "color 0.2s",
};

export default function Footer() {
  const navigate = useNavigate();

  return (
    <div style={{
      background: t.surfaceWarm,
      borderTop: `1px solid ${t.borderGold}`,
      padding: "20px 60px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 12,
    }}>
      {/* Logo */}
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <img src="/logo.png" alt="RealtyFlows" style={{ width: 22, height: 22, borderRadius: 3 }} />
        <span style={{ fontFamily: font.display, fontSize: 18, fontWeight: 700, letterSpacing: 1 }}>
          <span style={{ color: t.textMuted }}>Realty</span>
          <span style={{ color: t.gold }}>Flows</span>
        </span>
      </div>

      {/* Links — use <a> tags so crawlers (Google verification) can follow them */}
      <div style={{ display: "flex", gap: 24 }}>
        <a
          href="/privacy"
          style={{ ...linkStyle, textDecoration: "none" }}
          onMouseEnter={e => (e.currentTarget.style.color = t.gold)}
          onMouseLeave={e => (e.currentTarget.style.color = t.textMuted)}
          onClick={e => { e.preventDefault(); navigate("/privacy"); }}
        >Privacy</a>
        <a
          href="/terms"
          style={{ ...linkStyle, textDecoration: "none" }}
          onMouseEnter={e => (e.currentTarget.style.color = t.gold)}
          onMouseLeave={e => (e.currentTarget.style.color = t.textMuted)}
          onClick={e => { e.preventDefault(); navigate("/terms"); }}
        >Terms</a>
        <a
          href="/contact"
          style={{ ...linkStyle, textDecoration: "none" }}
          onMouseEnter={e => (e.currentTarget.style.color = t.gold)}
          onMouseLeave={e => (e.currentTarget.style.color = t.textMuted)}
          onClick={e => { e.preventDefault(); navigate("/contact"); }}
        >Contact</a>
      </div>

      {/* Copyright */}
      <div style={{
        fontSize: 10,
        color: t.textFaint,
        fontFamily: font.body,
        fontWeight: 700,
        letterSpacing: 1,
      }}>
        &copy; 2026 RealtyFlows. All rights reserved.
      </div>
    </div>
  );
}
